import script from "./GlobalLoadingOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoadingOverlay.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoadingOverlay.vue?vue&type=style&index=0&id=74e682de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e682de"]])

export default __exports__